import { useDispatch, useSelector } from 'react-redux';
import { getParticipant } from 'redux/requestSelectors';
import { requestActions, requestOperations } from '../redux';

export default () => {
  const dispatch = useDispatch();

  const getParticipantState = useSelector(getParticipant);

  const setParticipant = (participant) => dispatch(requestActions.setParticipant(participant));

  const createPerson = async (personPayload) => dispatch(requestOperations.createPerson(personPayload));

  const createPersonHefesto = async (personHefestoPayload) =>
    dispatch(requestOperations.createPersonHefesto(personHefestoPayload));

  const getPersonByDocument = async (documentNumber) =>
    dispatch(requestOperations.searchPersonByDocument(documentNumber));

  return {
    getParticipantState,
    setParticipant,
    createPerson,
    createPersonHefesto,
    getPersonByDocument,
  };
};
